import {Action} from '@ngrx/store';

export function entityReducer (state: any = {}, action: Action) {
  state[action.type] = action.payload;
  return state;
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/reducer/entity-reducer.service.ts